export enum EnumMeioDePagamento {
  Cielo = "cielo",
  CieloCheckout = "cielocheckout",
  Pagarme = "pagarme",
  Pagseguro = "pagseguro",
  MercadoPago = "mercadopago"
}
